(function($, _) {
  "use strict";

  var ns = nspace("ccc.indicatorSelection"),
    $downloadAwait = $("#downloadAwait");

  // set up window resize
  (function() {
    var updateLayout;

    // set up colorbox resize after window resize
    updateLayout = _.debounce(function() {
      $downloadAwait.colorbox.resize({ width: "600px" });
    }, 400);
    $(window).resize(updateLayout);
  })();

  var noTopicsSelected = true;

  ns.DownloadButton = function(model) {
    var self = model,
      $downloadFiles = $("#downloadFiles");

    $downloadFiles.click(function() {
      var indicators = self.get("selectedIndicators"),
        downloadHref,
        colorboxDownloader;

      if (
        indicators !== "0" &&
        indicators !== "" &&
        indicators !== null &&
        typeof indicators !== "undefined"
      ) {
        downloadHref = "/data/downloaddata/";

        $("#no-items-selected").val("false");

        colorboxDownloader = new ccc.components.ui.ColorboxDownloader(
          $downloadFiles,
          "#downloadAwait",
          downloadHref,
          {
            waiting: "#download-waiting",
            failure: "#download-failure",
            no_selection: "#download-no-selection",
          },
          "no-display",
          20000,
          "POST",
          {
            "indicators": indicators,
          },
        );
        colorboxDownloader.download();
      }
      else {
        $("#no-items-selected").val("true");

        $.colorbox({
          inline: true,
          href: "#downloadAwait",
          height: 200,
          width: 300,
          onComplete: function() {
            $("#download-no-selection").removeClass("no-display");
            $("#download-waiting, #download-failure").addClass("no-display");
            noTopicsSelected = true;
          },
          scrolling: false,
          transition: "none",
        });
      }
    });
  };
})(jQuery, _);
